export function getPreview(code: string) {
  return `https://cdn.jwplayer.com/v2/media/${code}/poster.jpg`;
}

export function getVideoUrl(code: string) {
  return `https://cdn.jwplayer.com/videos/${code}`;
}
